module.exports = __webpack_public_path__ + "imgs/twitter-white.31bfc95bfea1be9a21f7445979850f30.svg";